Auth = require 'app/scripts/db/auth'
TrelloClipboard = require 'app/scripts/lib/trello-clipboard'
TrelloModel = require 'app/scripts/models/internal/trello-model'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'

# TODO: This is a weird model that does not persist, and probably should
# not exist, at least not as an actual model.
# See https://trello.com/c/mvr7u2zf
module.exports = class BoardState extends TrelloModel
  sync: (method, model, options) ->
    throw new Error "BoardState is a special weird non-persistent thing"

  initialize: (data, options) ->
    super
    { @board } = options

    if @useSidebarPref()
      @setShowSidebarFromPref()
      @listenTo @board, 'change:myPrefs', @setShowSidebarFromPref
    else
      @set('showSidebar', !WindowSize.fSmall)

    @set('listComposerOpen', false)

  setSidebarDisplayType: (type) ->
    @set('sidebarDisplayType', type ? "")

  getSidebarDisplayType: ->
    @get('sidebarDisplayType')

  selectCard: (card) ->
    @_selectedList = null
    if card == @_selectedCard
      return

    if @_selectedCard
      @stopListening @_selectedCard, 'change:closed'

    @_selectedCard = card

    if @_selectedCard?
      @listenTo @_selectedCard, 'change:closed', =>
        @selectCardAfter(@_selectedCard)

      @waitForId @_selectedCard, =>
        # We may have created additional cards between the original selectCard
        # and now, so make sure we haven't selected something else
        if @_selectedCard == card
          TrelloClipboard.set(card.getFullUrl())

    @trigger 'active-card-changed'
    return

  selectList: (list) ->
    @_selectedList = list

  isCardSelected: (card) ->
    card? && (card == @_selectedCard)

  clearSelectedCard: ->
    @selectCard(null)

  getCard: ->
    @_selectedCard

  getList: ->
    card = @getCard()
    if card?
      card.getList()
    else
      @_selectedList

  selectCardAfter: (card) ->
    list = card.getList()
    visibleCards = list?.cardList.filter (card) => @board.filter.satisfiesFilter(card)

    nextCard =
      if !list? || visibleCards.length == 0
        null
      else
        comesAfter = (masterCard) =>
          (otherCard) ->
            otherCard != masterCard &&
            otherCard.get('pos') >= masterCard.get('pos')

        _.find(visibleCards, comesAfter(card))

    @selectCard(nextCard ? _.last(visibleCards))

  openListComposer: ->
    @set('listComposerOpen', true)

  closeListComposer: ->
    @$('.js-open-add-list').removeAttr('tabindex')
    @set('listComposerOpen', false)

  useSidebarPref: ->
    Auth.isLoggedIn() &&
      (WindowSize.fExtraLarge || WindowSize.fLarge || WindowSize.fMedium)

  setShowSidebar: (show) ->
    if show != @get('showSidebar')
      @set('showSidebar', show)

      # if we are currently in a state where the pref should be used, update it
      if @useSidebarPref()
        @board.setPref('showSidebar', show)

  setShowSidebarFromPref: ->
    @waitForAttr @board, 'myPrefs', =>
      @set 'showSidebar', @board.getPref('showSidebar')
